// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.directive('wuform', {
/* eslint-disable no-undef, no-unused-vars */
  inserted: (el) => {
    initForm();
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  data: function data() {
    return {
      navIsOpen: false,
    };
  },
  methods: {
    toggleNav: function toggleNav() {
      this.navIsOpen = !this.navIsOpen;
    },
    closeNav: function closeNav() {
      this.navIsOpen = false;
    },
  },
});